import {
  PeppolItemStatus,
  PeppolItemStatusConfig,
} from '../interfaces/peppol-item.interface';

export const PEPPOL_STATUS_CONFIG: Record<
  PeppolItemStatus,
  PeppolItemStatusConfig
> = {
  [PeppolItemStatus.Queued]: {
    icon: 'clock',
    colorClass: 'tertiary',
    label: 'PEPPOL.STATUS.Queued',
  },
  [PeppolItemStatus.Sent]: {
    icon: 'arrow_circle_right',
    colorClass: 'info',
    label: 'PEPPOL.STATUS.Sent',
  },
  [PeppolItemStatus.Delivered]: {
    icon: 'inbox_01',
    colorClass: 'cyan',
    label: 'PEPPOL.STATUS.Delivered',
  },
  [PeppolItemStatus.Error]: {
    icon: 'alert_circle',
    colorClass: 'error',
    label: 'PEPPOL.STATUS.Error',
  },
  [PeppolItemStatus.AB]: {
    icon: 'inbox_01',
    colorClass: 'cyan',
    label: 'PEPPOL.STATUS.AB',
  },
  [PeppolItemStatus.IP]: {
    icon: 'loading_01',
    colorClass: 'info',
    label: 'PEPPOL.STATUS.IP',
  },
  [PeppolItemStatus.AP]: {
    icon: 'check_circle',
    colorClass: 'success',
    label: 'PEPPOL.STATUS.AP',
  },
  [PeppolItemStatus.PD]: {
    icon: 'currency_dollar_circle',
    colorClass: 'success',
    label: 'PEPPOL.STATUS.PD',
  },
  [PeppolItemStatus.RE]: {
    icon: 'x_circle',
    colorClass: 'error',
    label: 'PEPPOL.STATUS.RE',
  },
  [PeppolItemStatus.CA]: {
    icon: 'alert_triangle',
    colorClass: 'warning',
    label: 'PEPPOL.STATUS.CA',
  },
  [PeppolItemStatus.UQ]: {
    icon: 'help_circle',
    colorClass: 'info',
    label: 'PEPPOL.STATUS.UQ',
  },
};

/**
 * Statuses offered by the status filter — every status the BE can report.
 *
 * TEMPORARY: `AB` is left out because it duplicates `Delivered` (same label in
 * every locale) and is not sent so far. Once BE drops `Delivered` in favour of
 * `AB`, remove the `filter`.
 */
export const PEPPOL_STATUS_FILTER_VALUES = Object.values(
  PeppolItemStatus,
).filter((status) => status !== PeppolItemStatus.AB);
